import React, { useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function DeleteRatingModal({ cancelModal, id, refreshData }) {
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const { user } = useAuthContext();
//styled
  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const deleteResponse = await axios.delete(
        `${ApiConnectionString}/api/Rating/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (deleteResponse.status === 200) {
        setComplete(true);
      }
    } catch (error) {
      console.error("Error deleting rating:", error);
    } finally {
      setIsLoading(false);
      refreshData();
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
      <LoadingSpinner /> 
        </div>
      </div>
    );
  } else {
    if (!complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Review</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
           <p>Are you sure you want to delete your review?</p>

            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleDelete}>
                Confirm
              </button>
              <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <h3>Deleted</h3>

            <div className="send-modal-footer">
              <button className="" onClick={cancelModal}>
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
